<template>
  <div>
    <PageLoader :storage="appLoading" />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" :color="snackColor" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: #fff">{{ msg }}</span>
        </v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: #fff">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-center>
      <v-flex xs12>
        <v-layout wrap justify-start pa-4>
          <v-flex xs12 class="d-flex align-center justify-space-between pb-2">
            <div>
              <span class="heading">Doctors Management</span>
              <div class="subheading text--secondary" v-if="hospitalName">
                Hospital: <strong>{{ hospitalName }}</strong>
              </div>
            </div>
            <v-btn color="#427D2D" small depressed @click="openAddDialog()">
              <v-icon small color="white" class="mr-1">mdi-plus</v-icon>
              <span style="font-size: 12px; font-family: poppinssemibold; color: white;">
                Add Doctor
              </span>
            </v-btn>
          </v-flex>

          <v-flex xs12 py-4 v-if="doctors && doctors.length > 0">
            <v-layout wrap justify-start pt-2>
              <v-flex xs12>
                <v-card flat outlined rounded="lg">
                  <div style="overflow-y: auto;">
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left tablehead">Doctor Name</th>
                            <th class="text-left tablehead">Phone Number</th>
                            <th class="text-left tablehead">District</th>
                            <th class="text-left tablehead">Specialization</th>
                            <th class="text-left tablehead">Date of Joining</th>
                            <th class="text-left tablehead">Availability Status</th>
                            <th class="text-left tablehead">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item, index) in doctors" :key="item._id || index">
                            <td style="white-space: nowrap;" class="tableitems font-weight-bold">
                              {{ item.name }}
                            </td>
                            <td style="white-space: nowrap;" class="tableitems">{{ item.phone }}</td>
                            <td style="white-space: nowrap;" class="tableitems">{{ item.district }}</td>
                            <td style="white-space: nowrap;" class="tableitems">{{ item.specialization || "General" }}</td>
                            <td style="white-space: nowrap;" class="tableitems">
                              {{ formatDate(item.dateOfJoining) }}
                            </td>
                            <td style="white-space: nowrap;" class="tableitems">
                              <v-chip
                                small
                                :color="item.status === 'Available' ? 'success' : 'orange'"
                                text-color="white"
                                class="font-weight-medium cursor-pointer"
                                @click="toggleStatus(item)"
                                title="Click to toggle status"
                              >
                                <v-icon left x-small>
                                  {{ item.status === 'Available' ? 'mdi-check-circle' : 'mdi-clock-outline' }}
                                </v-icon>
                                {{ item.status }}
                              </v-chip>
                            </td>
                            <td style="white-space: nowrap;">
                              <v-icon
                                small
                                color="primary"
                                class="mr-2 cursor-pointer"
                                @click.stop="openEditDialog(item)"
                                title="Edit Doctor"
                              >mdi-pencil</v-icon>
                              <v-icon
                                small
                                color="error"
                                class="cursor-pointer"
                                @click.stop="openDeleteDialog(item._id)"
                                title="Delete Doctor"
                              >mdi-delete</v-icon>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </div>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12 v-else pt-10>
            <v-layout wrap justify-center align-center pa-6 style="background:#f9f9f9; border-radius:12px;">
              <v-flex xs12 class="text-center">
                <v-icon size="40" color="grey">mdi-doctor</v-icon>
                <div class="nodata pt-2">No Doctors Added Yet!</div>
                <div class="caption text--secondary">Click "Add Doctor" to list doctors for your hospital.</div>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <!-- ADD DOCTOR DIALOG -->
    <v-dialog v-model="adddialog" max-width="700px" persistent>
      <v-card rounded="lg">
        <v-card-title class="d-flex align-center justify-space-between">
          <span class="heading">ADD NEW DOCTOR</span>
          <v-btn color="red" icon @click="adddialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-form ref="addForm">
            <v-layout wrap justify-start pt-2>
              <v-flex xs12 sm12 md6 lg6 pr-md-2 class="subheading">
                <span style="color:black">Doctor Name *</span>
                <v-text-field class="pt-2 text-des" outlined v-model="name" dense hide-details placeholder="Dr. Full Name"></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md6 lg6 class="subheading">
                <span style="color:black">Phone Number *</span>
                <v-text-field
                  class="pt-2 text-des"
                  outlined
                  v-model="phone"
                  dense
                  hide-details
                  maxlength="10"
                  placeholder="10-digit Phone"
                  @input="phone = (phone || '').replace(/[^0-9]/g, '').slice(0, 10)"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md6 lg6 pt-2 pr-md-2 class="subheading">
                <span style="color:black">District</span>
                <v-text-field
                  outlined
                  dense
                  hide-details
                  readonly
                  class="pt-2 text-des font-weight-bold"
                  v-model="district"
                  placeholder="Fetching Hospital District..."
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md6 lg6 pt-2 class="subheading">
                <span style="color:black">Date of Joining</span>
                <v-text-field class="pt-2 text-des" outlined v-model="dateOfJoining" type="date" dense hide-details></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md6 lg6 pt-2 pr-md-2 class="subheading">
                <span style="color:black">Specialization</span>
                <v-text-field class="pt-2 text-des" outlined v-model="specialization" dense hide-details placeholder="e.g. Toxicologist, General"></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md6 lg6 pt-2 class="subheading">
                <span style="color:black">Status</span>
                <v-select
                  outlined
                  hide-details
                  dense
                  :items="['Available', 'Unavailable']"
                  class="pt-2 text-des"
                  v-model="status"
                ></v-select>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>

        <v-card-actions class="py-4 justify-end headline lighten-2 pa-4">
          <v-btn tile outlined color="#FF1313" text @click="adddialog = false">
            <span>Cancel</span>
          </v-btn>
          <v-btn tile color="#427D2D" depressed @click="submitAdd()">
            <span style="color:white;">Submit</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- EDIT DOCTOR DIALOG -->
    <v-dialog v-model="editdialog" max-width="700px" persistent>
      <v-card rounded="lg">
        <v-card-title class="d-flex align-center justify-space-between">
          <span class="heading">EDIT DOCTOR DETAILS</span>
          <v-btn color="red" icon @click="editdialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-form ref="editForm">
            <v-layout wrap justify-start pt-2>
              <v-flex xs12 sm12 md6 lg6 pr-md-2 class="subheading">
                <span style="color:black">Doctor Name</span>
                <v-text-field class="pt-2 text-des" outlined v-model="editName" dense hide-details></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md6 lg6 class="subheading">
                <span style="color:black">Phone Number *</span>
                <v-text-field
                  class="pt-2 text-des"
                  outlined
                  v-model="editPhone"
                  dense
                  hide-details
                  maxlength="10"
                  placeholder="10-digit Phone"
                  @input="editPhone = (editPhone || '').replace(/[^0-9]/g, '').slice(0, 10)"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md6 lg6 pt-2 pr-md-2 class="subheading">
                <span style="color:black">District</span>
                <v-text-field
                  outlined
                  dense
                  hide-details
                  readonly
                  class="pt-2 text-des font-weight-bold"
                  v-model="editDistrict"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md6 lg6 pt-2 class="subheading">
                <span style="color:black">Date of Joining</span>
                <v-text-field class="pt-2 text-des" outlined v-model="editDateOfJoining" type="date" dense hide-details></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md6 lg6 pt-2 pr-md-2 class="subheading">
                <span style="color:black">Specialization</span>
                <v-text-field class="pt-2 text-des" outlined v-model="editSpecialization" dense hide-details></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md6 lg6 pt-2 class="subheading">
                <span style="color:black">Status</span>
                <v-select
                  outlined
                  hide-details
                  dense
                  :items="['Available', 'Unavailable']"
                  class="pt-2 text-des"
                  v-model="editStatus"
                ></v-select>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>

        <v-card-actions class="py-4 justify-end headline lighten-2 pa-4">
          <v-btn tile outlined color="#FF1313" text @click="editdialog = false">
            <span>Cancel</span>
          </v-btn>
          <v-btn tile color="#427D2D" depressed @click="submitEdit()">
            <span style="color:white;">Save Changes</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DELETE DIALOG -->
    <v-dialog v-model="deleteDialog" max-width="500">
      <v-card rounded="lg">
        <v-card-title class="heading">Remove Doctor</v-card-title>
        <v-card-text>
          Are you sure you want to remove this doctor record?
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn tile outlined color="#FF1313" @click="deleteDialog = false">
            Cancel
          </v-btn>
          <v-btn tile color="#427D2D" depressed @click="submitDelete()">
            <span style="color: #fff">Confirm</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "DoctorsList",
  data() {
    return {
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      snackColor: "#427D2D",
      timeout: 5000,
      msg: null,
      hospitalName: "",
      hospitalDistrict: "",
      doctors: [],

      // Add Form
      name: "",
      phone: "",
      district: "",
      dateOfJoining: new Date().toISOString().substr(0, 10),
      specialization: "General Physician",
      status: "Available",
      adddialog: false,

      // Edit Form
      editId: null,
      editName: "",
      editPhone: "",
      editDistrict: "",
      editDateOfJoining: "",
      editSpecialization: "",
      editStatus: "Available",
      editdialog: false,

      // Delete
      deleteId: null,
      deleteDialog: false,

      districts: [
        "Angul",
        "Boudh",
        "Balangir",
        "Bargarh",
        "Balasore",
        "Bhadrak",
        "Cuttack",
        "Deogarh",
        "Dhenkanal",
        "Ganjam",
        "Gajapati",
        "Jharsuguda",
        "Jajpur",
        "Jagatsinghapur",
        "Khordha",
        "Keonjhar",
        "Kalahandi",
        "Kandhamal",
        "Koraput",
        "Kendrapara",
        "Malkangiri",
        "Mayurbhanj",
        "Nabarangpur",
        "Nuapada",
        "Nayagarh",
        "Puri",
        "Rayagada",
        "Sambalpur",
        "Subarnapur",
        "Sundargarh"
      ]
    };
  },
  mounted() {
    this.getDoctors();
  },
  methods: {
    formatDate(dateStr) {
      if (!dateStr) return "-";
      try {
        const d = new Date(dateStr);
        return d.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric"
        });
      } catch (e) {
        return dateStr;
      }
    },

    getDoctors() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/hospital/doctor/list",
        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.doctors = response.data.data || [];
            this.hospitalName = response.data.hospitalName || "";
            this.hospitalDistrict = response.data.hospitalDistrict || "";
            this.district = this.hospitalDistrict;
          } else {
            this.msg = response.data.msg;
            this.snackColor = "#D32F2F";
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    openAddDialog() {
      this.name = "";
      this.phone = "";
      this.district = this.hospitalDistrict;
      this.dateOfJoining = new Date().toISOString().substr(0, 10);
      this.specialization = "General Physician";
      this.status = "Available";
      this.adddialog = true;
    },

    submitAdd() {
      const phoneRegex = /^[0-9]{10}$/;
      if (!this.name) {
        this.msg = "Please Provide Doctor Name.";
        this.snackColor = "#D32F2F";
        this.showSnackBar = true;
        return;
      }
      if (!this.phone) {
        this.msg = "Please Provide Phone Number.";
        this.snackColor = "#D32F2F";
        this.showSnackBar = true;
        return;
      }
      if (!phoneRegex.test(this.phone)) {
        this.msg = "Please Provide a Valid 10-digit Phone Number.";
        this.snackColor = "#D32F2F";
        this.showSnackBar = true;
        return;
      }
      if (!this.district) {
        this.msg = "Please Select District.";
        this.snackColor = "#D32F2F";
        this.showSnackBar = true;
        return;
      }

      this.appLoading = true;
      axios({
        method: "POST",
        url: "/hospital/doctor/add",
        headers: {
          "x-auth-token": localStorage.getItem("token")
        },
        data: {
          name: this.name,
          phone: this.phone,
          district: this.district,
          dateOfJoining: this.dateOfJoining,
          specialization: this.specialization,
          status: this.status
        }
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.msg = response.data.msg;
            this.snackColor = "#427D2D";
            this.showSnackBar = true;
            this.adddialog = false;
            this.getDoctors();
          } else {
            this.msg = response.data.msg;
            this.snackColor = "#D32F2F";
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    toggleStatus(item) {
      const newStatus = item.status === "Available" ? "Unavailable" : "Available";
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/hospital/doctor/update-status",
        headers: {
          "x-auth-token": localStorage.getItem("token")
        },
        data: {
          id: item._id,
          status: newStatus
        }
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            item.status = newStatus;
            this.msg = `Dr. ${item.name} is now marked as ${newStatus}`;
            this.snackColor = "#427D2D";
            this.showSnackBar = true;
          } else {
            this.msg = response.data.msg;
            this.snackColor = "#D32F2F";
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },

    openEditDialog(item) {
      this.editId = item._id;
      this.editName = item.name;
      this.editPhone = item.phone;
      this.editDistrict = item.district;
      this.editDateOfJoining = item.dateOfJoining ? new Date(item.dateOfJoining).toISOString().substr(0, 10) : "";
      this.editSpecialization = item.specialization || "";
      this.editStatus = item.status || "Available";
      this.editdialog = true;
    },

    submitEdit() {
      const phoneRegex = /^[0-9]{10}$/;
      if (!this.editName) {
        this.msg = "Please Provide Doctor Name.";
        this.snackColor = "#D32F2F";
        this.showSnackBar = true;
        return;
      }
      if (!this.editPhone || !phoneRegex.test(this.editPhone)) {
        this.msg = "Please Provide a Valid 10-digit Phone Number.";
        this.snackColor = "#D32F2F";
        this.showSnackBar = true;
        return;
      }

      this.appLoading = true;
      axios({
        method: "POST",
        url: "/hospital/doctor/edit",
        headers: {
          "x-auth-token": localStorage.getItem("token")
        },
        data: {
          id: this.editId,
          name: this.editName,
          phone: this.editPhone,
          district: this.editDistrict,
          dateOfJoining: this.editDateOfJoining,
          specialization: this.editSpecialization,
          status: this.editStatus
        }
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.msg = response.data.msg;
            this.snackColor = "#427D2D";
            this.showSnackBar = true;
            this.editdialog = false;
            this.getDoctors();
          } else {
            this.msg = response.data.msg;
            this.snackColor = "#D32F2F";
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    openDeleteDialog(id) {
      this.deleteId = id;
      this.deleteDialog = true;
    },

    submitDelete() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/hospital/doctor/delete",
        headers: {
          "x-auth-token": localStorage.getItem("token")
        },
        data: {
          id: this.deleteId
        }
      })
        .then((response) => {
          this.appLoading = false;
          this.deleteDialog = false;
          if (response.data.status) {
            this.msg = response.data.msg;
            this.snackColor = "#427D2D";
            this.showSnackBar = true;
            this.getDoctors();
          } else {
            this.msg = response.data.msg;
            this.snackColor = "#D32F2F";
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.deleteDialog = false;
          this.ServerError = true;
          console.log(err);
        });
    }
  }
};
</script>

<style scoped>
.heading {
  font-family: poppinssemibold;
  font-size: 20px;
  font-weight: 600;
}
.subheading {
  font-family: sofiaProRegular;
  font-size: 14px;
}
.tablehead {
  font-family: poppinssemibold;
  font-size: 13px;
  color: #000;
}
.tableitems {
  font-family: sofiaProRegular;
  font-size: 13px;
}
.nodata {
  font-family: poppinsregular;
  font-size: 16px;
  color: #777;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
